export default {
    agentWindows: 'agentWindows',
    sqlServer: 'sqlServer',

    hasUsernameAndPassword: function(authType) {
        return authType === this.sqlServer;
    }
};


// WEBPACK FOOTER //
// ./src/components/common/SqlServerInstanceSelection/sqlServerAuthTypes.js